export const WAEC_ACCOUNTING = [
  {
    q: "The accounting equation is:",
    o: ["Assets = Liabilities – Capital", "Assets = Liabilities + Capital", "Capital = Assets + Liabilities", "Liabilities = Assets + Capital"],
    a: 1,
    e: "Assets = Liabilities + Capital (Owner's Equity). This is the fundamental accounting equation.",
    h: "A = L + C",
    yr: "2023",
  },
  {
    q: "Which account is debited when a business buys goods on credit?",
    o: ["Cash account", "Creditors account", "Purchases account", "Sales account"],
    a: 2,
    e: "Purchases account is debited (increases) when goods are bought. Creditors account is credited.",
    h: "Debit the account that receives value.",
    yr: "2022",
  },
  {
    q: "Depreciation is charged on:",
    o: ["Current assets", "Fixed assets", "Liquid assets", "Intangible assets only"],
    a: 1,
    e: "Depreciation is the reduction in value of fixed (non-current) assets over their useful life.",
    h: "Things that lose value over time: machinery, vehicles.",
    yr: "2023",
  },
  {
    q: "A trial balance is used to:",
    o: ["Record all transactions", "Prepare financial statements", "Check arithmetical accuracy of ledger", "Calculate profit"],
    a: 2,
    e: "A trial balance lists all debit and credit balances to verify that total debits equal total credits.",
    h: "Checks if books balance.",
    yr: "2021",
  },
  {
    q: "Gross profit is calculated as:",
    o: ["Sales – Expenses", "Sales – Cost of Goods Sold", "Net profit + Expenses", "Revenue – Tax"],
    a: 1,
    e: "Gross Profit = Sales (Revenue) – Cost of Goods Sold (COGS). It does not include operating expenses.",
    h: "Before deducting expenses.",
    yr: "2022",
  },
];

export const WAEC_ACCOUNTING_LEARN = [
  {
    topic: "Double Entry Bookkeeping",
    content: "Every transaction has two equal and opposite effects. Debit = left side; Credit = right side. DEAD CLIC: Debits increase Expenses, Assets, Drawings. Credits increase Liabilities, Income, Capital. The ledger contains all accounts; the journal records transactions chronologically.",
  },
  {
    topic: "Final Accounts",
    content: "Trading Account: calculates Gross Profit = Sales – COGS. Profit & Loss Account: Gross Profit – Expenses = Net Profit. Balance Sheet: shows Assets, Liabilities, and Capital at a point in time. Assets = Liabilities + Capital always.",
  },
  {
    topic: "Depreciation Methods",
    content: "Straight-line: (Cost – Residual Value) / Useful life. Same amount each year. Reducing balance: Fixed % of book value each year; higher charge early on. Units of production: based on actual usage. Depreciation reduces asset value and is an expense in P&L.",
  },
  {
    topic: "Bank Reconciliation",
    content: "Bank statement balance ≠ cash book balance due to: unpresented cheques, deposits in transit, bank charges, errors. Reconciliation statement: start with bank balance, add deposits in transit, subtract unpresented cheques = adjusted balance. Then check cash book errors.",
  },
  {
    topic: "Ratio Analysis",
    content: "Liquidity: Current ratio = Current Assets / Current Liabilities (ideal ~2:1). Quick ratio excludes stock. Profitability: Gross profit % = Gross Profit / Sales × 100. Net profit % = Net Profit / Sales × 100. Return on Capital Employed (ROCE) = Net Profit / Capital × 100.",
  },
];
